// Centralised TanStack Query keys for the user entity. Other layers must
// import these factories instead of inlining string arrays.
export const userKeys = {
  all: ['user'] as const,
  profile: () => [...userKeys.all, 'profile'] as const,
  byId: (id: number) => [...userKeys.all, 'byId', id] as const,
};
